import React, { useEffect } from 'react';
import { useLocation } from '@reach/router';
import { navigate } from 'gatsby';
import ROUTES from '../../../routes';
import useInvoicePaymentAuth from '../../../hooks/invoice-payment-portal/useInvoicePaymentAuth';

interface IPrivateRoute {
  component: React.ComponentType<any>;
  path: string;
}

const PrivateInvoicePortalRoute = ({
  component: Component,
  ...rest
}: IPrivateRoute) => {
  const location = useLocation();
  const { isAuthenticated, isLoading } = useInvoicePaymentAuth();

  useEffect(() => {
    if (!isAuthenticated && !isLoading) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      navigate(ROUTES.INVOICE_PAYMENT_PORTAL_SIGN_IN, {
        state: { redirectUrl: location.pathname },
        replace: true,
      });
    }
  }, [isAuthenticated, isLoading]);

  // Don't render the component until authenticated
  if (isLoading || !isAuthenticated) {
    return null;
  }

  return <Component {...rest} />;
};

export default PrivateInvoicePortalRoute;
